const ActionTypes = {
    SHOW_LOADING_OVERLAY: 'SHOW_LOADING_OVERLAY',
    SCHEDULE_LOADING_OVERLAY: 'SCHEDULE_LOADING_OVERLAY',
    ADD_NOTIFICATION: 'ADD_NOTIFICATION',
    REMOVE_NOTIFICATIONS: 'REMOVE_NOTIFICATIONS',
    CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
    SHOW_ONBOARDING_GUIDE: 'SHOW_ONBOARDING_GUIDE',
    HIDE_ONBOARDING_GUIDE: 'HIDE_ONBOARDING_GUIDE',
    VIEW_ONBOARDING_PAGE: 'VIEW_ONBOARDING_PAGE',
    SET_R360_CONTEXT: 'SET_R360_CONTEXT',
};

export default ActionTypes;
